<script>
    import {colors, player} from '../store';
    export let x, y;
</script>

<use xlink:href="#player"  x="{x}" y="{y}" width=".7" height=".7"
    transform="rotate({$player.animatedDirection.value.degrees}, {$player.animatedPosition.centre.x}, {$player.animatedPosition.centre.y})" />
